import { createImageUrlBuilder } from '@sanity/image-url';
import type { CloudinaryAsset, SanityImage } from '../interfaces/Sanity';
import { cdnClient as client } from './sanity/client';

const builder = createImageUrlBuilder(client);

export function urlFor(source) {
  return builder.image(source);
}

export function calculateHeight(width: number, ratio: number): number {
  return ratio ? Math.round(width / ratio) : width;
}

export function roundUpNearestHundred(width: number): number {
  return Math.ceil(width / 100) * 100;
}

const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#CCCCCC50" offset="20%" />
      <stop stop-color="#99999950" offset="50%" />
      <stop stop-color="#CCCCCC50" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#cccccc50" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;

const toBase64 = (str: string) => {
  try {
    return typeof window === 'undefined'
      ? Buffer.from(str).toString('base64')
      : window.btoa(str);
  } catch (err) {
    console.error('Error converting to base64:', err);
    return str;
  }
};

export const blurUrl = (w: number, h: number) =>
  `data:image/svg+xml;base64,${toBase64(shimmer(w, h))}`;

// Type guards for SanityImage and CloudinaryAsset
export function isCloudinaryAsset(
  item: SanityImage | CloudinaryAsset
): item is CloudinaryAsset {
  return (
    (item as CloudinaryAsset)._type === 'cloudinaryAsset' ||
    (item as CloudinaryAsset)._type === 'cloudinary.asset' ||
    (item as CloudinaryAsset).asset?._type === 'cloudinary.asset'
  );
}

export function isSanityImage(
  item: SanityImage | CloudinaryAsset
): item is SanityImage {
  return (
    (item as SanityImage)._type === 'image' ||
    (item as SanityImage)._type === 'sanity.imageAsset'
  );
}
